/**
 * Departments API service
 */
import { apiClient as api } from '@/shared/utils/api';

export interface Department {
  department_id: string;
  name: string;
  code: string;
  description?: string;
  is_active?: boolean;
}

export interface DepartmentsResponse {
  departments?: Department[];
  results?: Department[];
  data?: Department[];
}

class DepartmentsService {
  async getDepartments(): Promise<{ data: Department[] }> {
    const response = await api.get<DepartmentsResponse>('/api/internal/facilities/departments/');

    // Handle different response formats
    const departments = response.data.departments ||
                       response.data.results ||
                       response.data.data ||
                       (Array.isArray(response.data) ? response.data : []);

    return { data: departments };
  }

  async getDepartment(id: string): Promise<{ data: Department }> {
    const response = await api.get<Department>(`/api/internal/facilities/departments/${id}`);
    return { data: response.data };
  }
}

export const departmentsService = new DepartmentsService();
export default departmentsService;
